import { Box, Card, Grid, Typography } from '@mui/material'
import FirstLayoutGrid from 'router/layouts/FirstLayoutGrid'
import useCheckInstallLocation from './useCheckInstallLocation'
import ErrorIcon from '@mui/icons-material/Error'
import useSubdomain from 'hooks/useSubdomain/useSubdomain'
import AdsList from './AdsList'
import { useCallback, useState } from 'react'

function InstallingScreen({
    onFinishInstall,
}: {
    onFinishInstall: () => void
}) {
    const [hasError, setHasError] = useState(false)
    const { subdomain } = useSubdomain()
    const onEndCheck = useCallback(
        (isSuccess: boolean) => {
            if (isSuccess) onFinishInstall()
            else setHasError(true)
        },
        [onFinishInstall],
    )

    useCheckInstallLocation(onEndCheck)

    return (
        <FirstLayoutGrid container spacing={2}>
            <Grid item xs={12}></Grid>
            <Grid item xs={12}>
                {hasError ? (
                    <Box>
                        <ErrorIcon fontSize={'large'} />

                        <Typography variant="h4" color="white">
                            Error while checking installation progress
                        </Typography>
                    </Box>
                ) : (
                    <Box
                        sx={{
                            display: 'flex',
                            width: '100%',
                            justifyContent: 'center',
                        }}
                    >
                        <Card
                            sx={{
                                width: {
                                    xs: 400,
                                    sm: 600,
                                    md: 800,
                                },
                                padding: 3,
                                m: 1,
                                textAlign: 'center',
                                backgroundColor: (t) => t.palette.primary.main,
                                borderRadius: 4,
                            }}
                        >
                            <AdsList />
                            <Typography
                                variant="h5"
                                color="white"
                                sx={{ mt: 2 }}
                            >
                                {`Installing ${subdomain} ...`}
                            </Typography>
                        </Card>
                    </Box>
                )}
            </Grid>
        </FirstLayoutGrid>
    )
}

export default InstallingScreen
